import { render } from "./CardPackage.vue?vue&type=template&id=7c2f4092"
import script from "./CardPackage.vue?vue&type=script&lang=js"
export * from "./CardPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__